<template>
  <div>
    <page-title>{{ PageTitle }}</page-title>

    <loading v-if="loading"></loading>
    <section-block v-else>
      <template slot="header">
        <filter-bar
          :showSearch="true"
          :showFilter="true"
          resource="News"
          :filterOptions="newsCategories"
          v-if="showSearch"
          filter-url-param="categories"
        />
        <p v-else>Filter bar</p>
      </template>
      <template slot="actions">
        <inline-list :ordered="false">
          <li>
            <block-link
              href="#"
              @click="toggleGrid(true)"
              :class="{ active: gridLayout, inactive: !gridLayout }"
              title="View as a grid"
            >
              <icon name="grid" width="18" height="18" />
            </block-link>
          </li>
          <li>
            <block-link
              href="#"
              @click="toggleGrid(false)"
              :class="{ active: !gridLayout, inactive: gridLayout }"
              title="View as a list"
            >
              <icon name="list" width="18" height="18" />
            </block-link>
          </li>
        </inline-list>
      </template>

      <section>
        <div v-if="articles.length < 1">
          <p>Sorry, there are no articles at the moment</p>
        </div>

        <inline-list
          v-else
          :ordered="true"
          :class="{ row: !gridLayout }"
          withPadding
          role="list"
        >
          <li
            v-for="article in articles"
            :key="article.id"
            :class="{
              'col-xs-12 col-md-4': gridLayout,
              'col-xs-12': !gridLayout,
            }"
            role="listitem"
          >
            <card-grid
              v-bind="article"
              @click="handleClick"
              tabindex="0"
              @keyup.enter="handleClick"
              v-if="gridLayout"
            ></card-grid>
            <card-list
              v-bind="article"
              @click="handleClick"
              tabindex="0"
              @keyup.enter="handleClick"
              :asLink="true"
              v-else
            ></card-list>
          </li>
        </inline-list>
      </section>
      <pagination
        v-if="articles.length > 0"
        :pagination="pagination"
        @onPageClick="gotoPage"
        :current="pagination.current_page"
      />
    </section-block>
  </div>
</template>

<script>
// TODO: Load up list of stories, on click go to story, using state
import CardGrid from "@/components/Containers/BaseCardGrid";
import CardList from "@/components/Containers/BaseCardList";
import InlineList from "@/components/Lists/InlineList";
import BlockLink from "@/components/Links/BaseLinkBlock";
import Pagination from "@/components/pagination";
import querySearch from "@/mixins/querySearch";
import { mapState } from "vuex";

export default {
  components: {
    CardGrid,
    CardList,
    InlineList,
    BlockLink,
    Pagination,
  },
  mixins: [querySearch],
  async created() {
    const vm = this;
    /**
     * If we have stuff in state, but its' NOT in the query string, put it in
     * TODO: Need to functionise this
     *
     */

    this.$store.commit("News/SET_TRUST_FILTER", false);
    this.$store.commit("News/SET_PUBLISHED_FILTER", true);

    // from querySearch mixin
    this.setFiltersFromQuery('News')

    await this.$store.dispatch("News/list", { isFlat: true });

    // also need categories
    await this.$store.dispatch("NewsCategories/list", { flat: true });
    const { tab } = vm.$route.params;
    if (!vm.$route.meta.openPanel) {
      vm.$store.commit("documents/setTabFilter", tab);
    }
    this.loading = false;
    return;
  },
  data() {
    return {
      PageTitle: "Latest Trust News",
      loading: true,
      articleList: [],
      showSearch: true,
      searchQuery: "",
    };
  },
  computed: {
    ...mapState("News", ["articles", "pagination"]),
    newsCategories() {
      return this.$store.getters["NewsCategories/formatCategories"];
    },
    gridLayout: {
      get() {
        return this.$store.state.News.gridLayout;
      },
      set(newVal) {
        this.$store.dispatch("News/toggleGrid", newVal);
      },
    },
  },
  methods: {
    handleClick(articleId) {
      this.$router.push({
        name: "NewsRead",
        params: { id: articleId },
      });
    },
    toggleGrid(val) {
      this.gridLayout = val;
    },
    async gotoPage(page) {
      // this.loading = true;
      this.$store.commit("News/setPage", page);

      // let resp;

      try {
        resp = await this.$store.dispatch("News/list", { isFlat: true });
      //   this.loading = false;
      //   window.scroll(0, 0);
      } catch (err) {
        console.log("🚀 ~ file: index.vue ~ line 172 ~ gotoPage ~ err)", err);
      }
    },
  },
};
</script>
